var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',[_vm._v("Debounce Demo")]),_c('DebounceInput',{attrs:{"debounce":1000,"clearable":"","placeholder":"Debounced input..."},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}),_c('p',[_vm._v("Debounced Value: "+_vm._s(_vm.inputValue))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }